export default class CustomerStories {
    constructor(element) {
        this.selector = element;

        this.initSlider();
    }

    async initSlider() {
        const target = this.selector.querySelector('[data-slider]');

        if (!target) {
            return;
        }

        const { default: Glide } = await import('@glidejs/glide');
        this.Glide = Glide;

        const slider = this.mountSlider();

        this.slidePrev(slider);
        this.slideNext(slider);
        this.changeSlide(slider);

        slider.on('run.after', () => {
            this.updateSliderActiveBullet(slider.index);
            this.updateSliderActiveButton(slider.index);
        });
    }

    mountSlider() {
        return new this.Glide(this.selector, {
            type: 'slider',
            perView: 1,
            animationDuration: 500,
            rewindDuration: 500,
            animationTimingFunc: 'ease-in-out',
            gap: 8,
            rewind: true,
            bound: true,
        }).mount();
    }

    slidePrev(slider) {
        const button = this.selector.querySelector('[data-slider-button="prev"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('<');
        });
    }

    slideNext(slider) {
        const button = this.selector.querySelector('[data-slider-button="next"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('>');
        });
    }

    changeSlide(slider) {
        const buttons = this.selector.querySelectorAll('[data-slider-button]');

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                slider.go(`=${button.dataset.sliderButton}`);
            });
        });
    }

    updateSliderActiveBullet(index) {
        const bullets = this.selector.querySelectorAll('[data-slider-bullet]');
        const activeBullet = this.selector.querySelector('[data-slider-bullet].active-slider-bullet');

        if (bullets.length === 0) {
            return;
        }

        activeBullet.classList.remove('active-slider-bullet');
        bullets[index].classList.add('active-slider-bullet');
    }

    updateSliderActiveButton(index) {
        const container = this.selector.querySelector('[data-slider-buttons]');
        const buttons = this.selector.querySelectorAll('[data-slider-button]');
        const activeButton = this.selector.querySelector('[data-slider-button].slider-button-active');

        if (buttons.length === 0) {
            return;
        }

        activeButton.classList.remove('slider-button-active');
        buttons[index].classList.add('slider-button-active');

        container.scrollTo({
            left: buttons[index].getBoundingClientRect().left - container.getBoundingClientRect().left + container.scrollLeft - 8,
            behavior: 'smooth'
        });
    }
}